export class ShippingTermsDto{
    shippingTermsId : number;
    shippingTermsName : string;
    isActive: boolean;
    createdUser : string;
    
    /**
     * 
     * @param shippingTermsId number
     * @param shippingTermsName string
     * @param isActive boolean
     * @param createdUser string
     */
    constructor(shippingTermsId : number,shippingTermsName : string,isActive: boolean,createdUser : string){
        this.shippingTermsId = shippingTermsId;
        this.shippingTermsName = shippingTermsName;
        this.isActive= isActive;
        this.createdUser= createdUser;
    }
}
export const ShippingTermsDtoDefault : ShippingTermsDto = {
    shippingTermsId: 0,
    shippingTermsName: '',
    isActive: true,
    createdUser : '',


}; 